import { SearchState } from '../../../models';
import { SEARCH_GETTERS_KEYS } from '../search.const';
import { SearchGetter } from '../search.interfaces';

export class HasMoreResultsGetter implements SearchGetter {

  getters = {
    [SEARCH_GETTERS_KEYS.hasMoreResults]: (searchState: SearchState): boolean => {
      return searchState.results.length < searchState.numFound;
    }
  };
}
